import * as React from 'react';
import { Panel } from './panel';
export const Accordion = ({ open = -1, items, duration, multiple }) => {
    const [activeTab, setActiveTab] = React.useState(open);
    return Array.isArray(items) && items.length ? (React.createElement("div", { className: "accordion", role: "tablist" }, items.map(({ open, title, content }, index) => (React.createElement(Panel, { key: index, open: open, title: title, index: index, duration: duration, multiple: multiple, activeTab: activeTab, activatePanel: (i) => {
            if (multiple) {
                return;
            }
            setActiveTab(activeTab === i ? -1 : i);
        } }, content))))) : null;
};
//# sourceMappingURL=accordion.js.map